import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const PrintAgentPage = lazy(
  () => import("../../../../components/WMS/Labels/PrintAgentPage"),
)

export const Route = createFileRoute("/_layout/WMS/products/print-agent")({
  component: PrintAgentRoute,
})

function PrintAgentRoute() {
  return (
    <LazyRoutePage>
      <PrintAgentPage />
    </LazyRoutePage>
  )
}
